import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import hero_bg from "../assets/new_hero_img.jpg";
import haribalajibanner1 from "../assets/hariballajibanner3.jpg";
import haribalajibanner3 from "../assets/imgbg.jpg";
import haribalajibanner2 from "../assets/banner4.gif";

import bgimage from "../assets/bgimg.jpg";
import banner3 from "../assets/banner2.gif";
import banner1 from "../assets/harihome.png";
import crackerbanner5 from "../assets/crackerbanner5.jpg";
import safetyBg from "../assets/safety-6.jpg";
import Qr from "../assets/QRlocation.png";
import gift1 from "../assets/haribalaji_banner1.png";
import gift2 from "../assets/haribalaji_banner2.png";
import html2canvas from 'html2canvas';
import shopnow from "../assets/shopnow1.png";
import { jsPDF } from 'jspdf';
import priceListImage from "../assets/pricelist.png";

import axios from "axios";
import API_BASE_URL from "./apiConfig";
import {
  FiMapPin, FiPhone, FiMail, FiClock, FiSend,
  FiUser, FiCheck, FiAlertTriangle, FiShield,
  FiAward, FiShoppingCart, FiStar, FiHeart,
  FiChevronLeft, FiChevronRight, FiMessageCircle, FiSmartphone, FiNavigation, FiDownload
} from 'react-icons/fi';
import priceListPDF from "../assets/HariBalajiPriceList2026.pdf";
import Header from './HeaderLayouts';
import Footer from './FooterLayouts';
function Home() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [currentBanner, setCurrentBanner] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showPriceList, setShowPriceList] = useState(true); // Changed to true to display
  const [isHovered, setIsHovered] = useState(false);
  const [welcomeImageIndex, setWelcomeImageIndex] = useState(0); // 👈 ADD THIS
  const welcomeImages = [gift1]; // 👈 ADD THIS
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    companyId: 3
  });

  // Banner images array - UPDATE THESE WITH HARIBALAJI TRADERS BANNERS
  const banners = [
    {
      id: 1,
      image: haribalajibanner1,
      title: "Hari balaji Traders",
      subtitle: "Premium fireworks for your magnificent celebrations"
    },
    {
      id: 2,
      image: haribalajibanner2,
      title: "Quality & Safety Guaranteed",
      subtitle: "Experience the finest and safest fireworks for your family"
    },
    {
      id: 3,
      image: haribalajibanner3,
      title: "Spectacular Celebrations",
      subtitle: "Light up your special moments with our premium crackers"
    },
    {
      id: 4,
      image: banner3,
      title: "Wholesale Prices",
      subtitle: "Best quality fireworks at unbeatable wholesale rates"
    },
    {
      id: 5,
      image: bgimage,
      title: "Best Prices Guaranteed",
      subtitle: "Quality fireworks at the most competitive wholesale prices"
    }
  ];

  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  const productsPerPage = 5;
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);

  // Scroll detection to show/hide floating buttons
  useEffect(() => {
    const handleScroll = () => {
      // Show buttons after scrolling 300px down
      if (window.scrollY > 300) {
        setShowFloatingButtons(true);
      } else {
        setShowFloatingButtons(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/Crackers/GetProductSummary?CompanyId=3`);
        if (response.data.statusCode === 200 && Array.isArray(response.data.result)) {
          // Limit to only 5 products
          setFeaturedProducts(response.data.result.slice(0, 5));
        }
      } catch (error) {
        console.error("Error fetching products for home screen:", error);
      } finally {
        setProductsLoading(false);
      }
    };
    fetchFeaturedProducts();
  }, []);

  // Navigation functions for product carousel
  const handleNextProducts = () => {
    if (currentProductIndex + productsPerPage < featuredProducts.length) {
      setCurrentProductIndex(currentProductIndex + productsPerPage);
    }
  };

  const handlePrevProducts = () => {
    if (currentProductIndex - productsPerPage >= 0) {
      setCurrentProductIndex(currentProductIndex - productsPerPage);
    }
  };

  // Get current products to display
  const currentProducts = featuredProducts.slice(currentProductIndex, currentProductIndex + productsPerPage);

  // Product categories
  const productCategories = [
    {
      id: 1,
      name: "GROUND CHAKKARS",
      description: "Ignite the joy with our triple-quality spinners that promise to turn your celebrations into an unforgettable spectacle!",
      icon: "🔄"
    },
    {
      id: 2,
      name: "SOUND CRACKERS",
      description: "Elevate your festivities with our Sound Crackers, the ultimate catalyst for sporting joy and vibrancy in your celebrations!",
      icon: "💥"
    },
    {
      id: 3,
      name: "SPARKLERS",
      description: "Transform your celebrations into magical moments with the radiant glow of our dazzling sparklers!",
      icon: "✨"
    },
    {
      id: 4,
      name: "ROCKETS",
      description: "Set the sky alive with our spectacular rockets! Elevate every occasion to extraordinary heights!",
      icon: "🚀"
    },
    {
      id: 5,
      name: "FLOWER POTS",
      description: "Experience a kaleidoscope of marvelous colors with our Flower Pots, sharing each extraordinary moment!",
      icon: "🏺"
    },
    {
      id: 6,
      name: "SKY CRACKERS",
      description: "Experience the brilliance of the night sky with our Sky Crackers, meticulously crafted to paint the darkness!",
      icon: "🌌"
    }
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto slide banner with right to left transition
  useEffect(() => {
    const interval = setInterval(() => {
      handleNextBanner();
    }, 5000);

    return () => clearInterval(interval);
  }, [banners.length]);

  const handleNextBanner = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
      setIsTransitioning(false);
    }, 800);
  };

  const handlePrevBanner = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentBanner((prev) => (prev - 1 + banners.length) % banners.length);
      setIsTransitioning(false);
    }, 800);
  };
  const openPriceListPDF = (e) => {
    e.preventDefault();
    window.open(priceListImage, '_blank'); // Opens PDF in new tab
  };
  const goToBanner = (index) => {
    if (index === currentBanner) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentBanner(index);
      setIsTransitioning(false);
    }, 800);
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingContact(true);
    setSubmitStatus(null);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('Name', formData.name);
      formDataToSend.append('Email', formData.email);
      formDataToSend.append('Phone', formData.phone || '');
      formDataToSend.append('Subject', formData.subject || 'General Inquiry');
      formDataToSend.append('Message', formData.message);
      formDataToSend.append('CompanyId', formData.companyId);

      const response = await axios.post(
        `${API_BASE_URL}api/Crackers/SendContactEmail`,
        formDataToSend,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.statusCode === 200) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: '', message: '', companyId: 3 });
        setTimeout(() => setSubmitStatus(null), 3000);
      } else {
        throw new Error(response.data.statusDesc || "Failed to send message");
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus('error');
    } finally {
      setIsSubmittingContact(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Responsive styles that need access to isMobile
  const homeheadImage = {
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    height: isMobile ? '40px' : '100px',
    width: 'auto',
    objectFit: 'contain',
    zIndex: 10,
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))',
  };

  const phoneNumberTopLeft = {
    position: 'absolute',
    top: isMobile ? '10px' : '20px',
    left: isMobile ? '5px' : '20px',
    fontSize: isMobile ? '0.5rem' : '0.9rem',
    fontWeight: '700',
    color: '#000000',
    backgroundColor: '#ffffff',
    border: isMobile ? '1px solid #f5ae42ff' : '3px solid #f5ae42ff',
    padding: isMobile ? '4px 6px' : '8px 15px',
    borderRadius: '15px',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? '2px' : '6px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
    zIndex: 10,
    animation: 'phoneNumberBlink 2s ease-in-out infinite',
  };

  const phoneNumberTopRight = {
    position: 'absolute',
    top: isMobile ? '10px' : '20px',
    right: isMobile ? '5px' : '20px',
    fontSize: isMobile ? '0.5rem' : '0.9rem',
    fontWeight: '700',
    color: '#000000',
    backgroundColor: '#ffffff',
    border: isMobile ? '1px solid #f5ae42ff' : '3px solid #f5ae42ff',
    padding: isMobile ? '4px 6px' : '8px 15px',
    borderRadius: '15px',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? '2px' : '6px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
    zIndex: 10,
    animation: 'phoneNumberBlink 2s ease-in-out infinite',
  };

  const phoneNumberTopRight2 = {
    position: 'absolute',
    top: isMobile ? '45px' : '70px',
    right: isMobile ? '5px' : '20px',
    fontSize: isMobile ? '0.5rem' : '0.9rem',
    fontWeight: '700',
    color: '#000000',
    backgroundColor: '#ffffff',
    border: isMobile ? '1px solid #f5ae42ff' : '3px solid #f5ae42ff',
    padding: isMobile ? '4px 6px' : '8px 15px',
    borderRadius: '15px',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? '2px' : '6px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
    zIndex: 10,
    animation: 'phoneNumberBlink 2s ease-in-out infinite',
  };

  const companyLogoRightEnd = {
    position: 'absolute',
    bottom: isMobile ? '10px' : '20px',
    right: isMobile ? '10px' : '20px',
    height: isMobile ? '40px' : '120px',
    width: 'auto',
    objectFit: 'contain',
    zIndex: 10,
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))',
  };

  const perumalBannerImageLeft = {
    position: 'absolute',
    top: '50%',
    left: isMobile ? '5px' : '20px',
    transform: 'translateY(-50%)',
    height: isMobile ? '60px' : '300px',
    width: 'auto',
    objectFit: 'contain',
    zIndex: 10,
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))',
  };

  const companyNameBanner = {
    fontSize: isMobile ? '1.5rem' : '3.5rem',
    fontWeight: '900',
    color: '#ff0000',
    textShadow: '4px 4px 8px rgba(0, 0, 0, 0.8)',
    letterSpacing: isMobile ? '2px' : '4px',
    marginBottom: isMobile ? '8px' : '15px',
    fontFamily: "'Arial Black', sans-serif",
    whiteSpace: isMobile ? 'normal' : 'nowrap',
  };

  const companyNameBannerTop = {
    position: 'absolute',
    top: isMobile ? '55px' : '120px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: isMobile ? '1rem' : '3.5rem',
    fontWeight: '900',
    color: '#ff0000',
    textShadow: '4px 4px 8px rgba(0, 0, 0, 0.8)',
    letterSpacing: isMobile ? '1px' : '4px',
    fontFamily: "'Arial Black', sans-serif",
    whiteSpace: isMobile ? 'normal' : 'nowrap',
    zIndex: 10,
    textAlign: 'center',
    padding: isMobile ? '0 10px' : '0',
  };

  const shopNowButtonContainer = {
    position: 'absolute',
    bottom: isMobile ? 'auto' : '80px',
    top: isMobile ? '140px' : 'auto',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
  };

  const primaryButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: isMobile ? '0.6rem 0.8rem' : '1.0rem 1.3rem',
    background: '#ffffff',
    color: '#5e045bff',
    textDecoration: 'none',
    borderRadius: isMobile ? '20px' : '30px',
    fontWeight: '700',
    fontSize: isMobile ? '0.75rem' : '1.1rem',
    transition: 'all 0.3s ease',
    border: isMobile ? '1px solid #5e045bff' : '2px solid #5e045bff',
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: isMobile ? '0.5px' : '1px',
    boxShadow: '0 15px 35px rgba(94, 4, 91, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  };

  return (
    <>
      <style>
        {`
  @keyframes pulse {
    0% {
      box-shadow: 0 0 15px 3px rgba(212, 55, 55, 0.6);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 0 25px 8px rgba(212, 55, 55, 0.9);
      transform: scale(1.05);
    }
    100% {
      box-shadow: 0 0 15px 3px rgba(212, 55, 55, 0.6);
      transform: scale(1);
    }
  }

  @keyframes blink {
    0%, 100% {
      opacity: 3;
    }
    50% {
      opacity: 0.3;
    }
  }

  @keyframes phoneNumberBlink {
    0%, 100% {
      background-color: #ffffff;
      border-color: #f5ae42ff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
    50% {
      background-color: #fff9e6;
      border-color: #ff9800;
      box-shadow: 0 4px 20px rgba(245, 174, 66, 0.8), 0 0 15px rgba(255, 152, 0, 0.6);
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Product Card Hover Effects */
  .product-card:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 50px rgba(94, 4, 91, 0.4) !important;
  }

  /* Feature Card Hover Effects */
  .feature-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(94, 4, 91, 0.4) !important;
    border-color: #5e045bff !important;
  }

  .feature-card:hover .feature-icon {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 20px 40px rgba(94, 4, 91, 0.6) !important;
  }

  /* Safety Card Hover Effects */
  .safety-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(94, 4, 91, 0.4) !important;
  }

  /* Button Hover Effects */
  .product-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 40px rgba(94, 4, 91, 0.7) !important;
  }

  .submit-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 40px rgba(94, 4, 91, 0.7) !important;
  }

  .primary-button:hover {
    background: linear-gradient(145deg, #cbafca 0%, #cbafca 100%) !important;
    color: #ffffff !important;
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 20px 45px rgba(203, 175, 202, 0.7) !important;
  }

  /* Shop Now Button Hover */
  .shop-now-button:hover {
    background: #ffffff !important;
    color: #cbafca !important;
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 15px 40px rgba(203, 175, 202, 0.8) !important;
    border: 3px solid #cbafca !important;
  }

  /* Hide navigation arrows in mobile view */
  @media (max-width: 768px) {
    .nav-arrow, .product-nav-arrow {
      display: none !important;
    }
    
    .banner-button-group {
      margin-bottom: 3rem !important;
    }
    
    .featured-products-grid {
      display: flex !important;
      grid-template-columns: none !important;
      overflow-x: auto !important;
      scroll-snap-type: x mandatory !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
      padding-bottom: 10px !important;
    }
    
    .featured-products-grid::-webkit-scrollbar {
      display: none !important;
    }
    
    .featured-product-card {
      flex: 0 0 200px !important;
      scroll-snap-align: start !important;
    }
  }

  /* Reduce floating buttons size in mobile */
  @media (max-width: 768px) {
    .shop-now-floating {
      max-width: 80px !important;
      bottom: 120px !important;
      right: 10px !important;
    }
    
    .price-list-floating {
      max-width: 80px !important;
      bottom: 50px !important;
      right: 10px !important;
    }
  }

  /* Input Focus Effects */
  .contact-input:focus {
    border-color: #cbafca !important;
    box-shadow: 0 0 0 3px rgba(203, 175, 202, 0.2) !important;
  }

  /* Map and QR Container Hover */
  .map-container:hover, .qr-container:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 50px rgba(94, 4, 91, 0.3) !important;
    border-color: #5e045bff !important;
  }

  /* Sparkle animation for banner */
  @keyframes sparkle {
    0%, 100% {
      opacity: 0;
      transform: scale(0);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .sparkle-dot {
    position: absolute;
    width: 4px;
    height: 4px;
    background: white;
    border-radius: 50%;
    animation: sparkle 3s infinite;
  }

  .sparkle-1 { top: 20%; left: 20%; animation-delay: 0s; }
  .sparkle-2 { top: 40%; left: 80%; animation-delay: 0.5s; }
  .sparkle-3 { top: 60%; left: 30%; animation-delay: 1s; }
  .sparkle-4 { top: 80%; left: 70%; animation-delay: 1.5s; }
  .sparkle-5 { top: 30%; left: 50%; animation-delay: 2s; }
  .sparkle-6 { top: 70%; left: 60%; animation-delay: 2.5s; }
  .sparkle-7 { top: 50%; left: 10%; animation-delay: 0.8s; }
  .sparkle-8 { top: 90%; left: 40%; animation-delay: 1.8s; }
`}
      </style>
      {/* <div style={topContactBar}>
  <div style={container}>
    <div style={topContactContent}>
      <div style={contactInfoItems}>
        <div style={contactInfoItem}>
          <FiPhone style={contactInfoIcon} />
          <span>+91 9344254344 | +91 6374181944</span>
        </div>
        <div style={contactInfoItem}>
          <FiMail style={contactInfoIcon} />
          <span>haribalajitraders@gmail.com</span> // Updated email
        </div>
        <div style={contactInfoItem}>
          <FiMapPin style={contactInfoIcon} />
          <span>Haribalaji Traders, 8QHR+2Q2, Surarpatti, Tamil Nadu 626131</span> // Updated address
        </div>
      </div>
      <div style={estimateButton}>
        <Link to="/estimate" style={estimateButtonLink}>
          <FiMessageCircle style={{ marginRight: '8px' }} />
          ESTIMATE NOW
        </Link>
      </div>
    </div>
  </div>
</div> */}

      <Header isMobile={isMobile} />

      {/* ADD THIS YELLOW LINE BELOW HEADER */}
      <div style={headerBottomBorder}></div>

      {showPriceList && showFloatingButtons && (
        <div style={priceListContainer} className="price-list-floating">
          <img
            src={priceListImage}
            alt="Price List - Click to Download PDF"
            style={{
              ...priceListImg,
              cursor: 'pointer',
              animation: 'pulse 2s infinite',
              transition: 'all 0.3s ease',
            }}
            onClick={handlePriceListDownload}
            title="Click to download price list PDF"
          />
        </div>
      )}
      {showFloatingButtons && (
        <div style={shopNowContainer} className="shop-now-floating">
          <div style={shopNowContent}>
            <img
              src={shopnow}
              alt="Special Offer - Shop Now"
              style={shopNowImg}
              onClick={() => navigate('/quick-purchase')}
              title="Click to shop now"
            />
          </div>
        </div>
      )}
      {/* Banner Section */}
      <section style={isMobile ? mobileBannerSection : bannerSection}>
        {/* Homehead Image at Top Center - No Background */}
        <img 
          src={require('../assets/homehead.png')} 
          alt="Home Header" 
          style={homeheadImage}
          onError={(e) => { e.target.style.display = 'none' }}
        />
        
        {/* Phone Number - ONLINE (Left Side) */}
        <a href="tel:+918438635396" style={phoneNumberTopLeft}>
          📞 ONLINE: +91 84386 35396
        </a>
        
        {/* Phone Number - Top Right (First) */}
        <a href="tel:+919843655396" style={phoneNumberTopRight}>
          📞 +91 98436 55396
        </a>
        
        {/* Phone Number - Top Right (Second, Below First) */}
        <a href="tel:+919751043474" style={phoneNumberTopRight2}>
          📞 +91 97510 43474
        </a>
        
        {/* Perumal Image on Left Side - No Background */}
        <img 
          src={require('../assets/perumalhome.png')} 
          alt="Perumal" 
          style={perumalBannerImageLeft}
          onError={(e) => { e.target.style.display = 'none' }}
        />
        
        {/* Company Logo at Right End Bottom - No Background */}
        <img 
          src={require('../assets/HaribalajiLogo.png')} 
          alt="Hari Balaji Logo" 
          style={companyLogoRightEnd}
          onError={(e) => { e.target.style.display = 'none' }}
        />

        <div style={bannerContainer}>
          {/* HARI BALAJI TRADERS text below homehead image */}
          {/* <h1 style={companyNameBannerTop}>
            HARI BALAJI TRADERS
          </h1> */}
          
          {banners.map((banner, index) => (
            <div
              key={banner.id}
              style={{
                ...bannerSlide,
                backgroundImage: `url(${banner.image})`,
                opacity: index === currentBanner ? 1 : 0,
                transition: 'opacity 1s ease-in-out',
                zIndex: index === currentBanner ? 2 : 1,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              {/* Overlay for better text visibility */}
              <div style={bannerOverlay}></div>

              {/* Banner Text Content */}
              <div style={bannerContent}>
                <h1 style={isMobile ? mobileBannerTitle : bannerTitle}>
                 HARI BALAJI TRADERS
                </h1> 
                <p style={isMobile ? mobileBannerSubtitle : bannerSubtitle}>
                  Discover the finest collection of Sivakasi crackers at wholesale prices.<br />
                  Safe, Certified & Spectacular Fireworks for Every Occasion!
                </p>
              </div>

            </div>
          ))}

          {/* Navigation Arrows */}
          {/* <button style={navButtonPrev} className="nav-arrow" onClick={handlePrevBanner}>
            <FiChevronLeft />
          </button>
          <button style={navButtonNext} className="nav-arrow" onClick={handleNextBanner}>
            <FiChevronRight />
          </button> */}

          {/* Indicators */}
          <div style={bannerIndicators}>
            {banners.map((_, index) => (
              <button
                key={index}
                style={{
                  ...bannerIndicator,
                  ...(index === currentBanner ? activeIndicator : {})
                }}
                onClick={() => goToBanner(index)}
              />
            ))}
          </div>
          
          {/* Shop Now Button below indicators */}
          <div style={shopNowButtonContainer}>
            <Link to="/quick-purchase" style={primaryButtonStyle} className="primary-button">
              <FiShoppingCart style={{ marginRight: isMobile ? '5px' : '10px', fontSize: isMobile ? '0.9rem' : '1rem' }} />
              Shop Now
            </Link>
          </div>
        </div>
      </section>

      {/* Welcome Section */}
      {/* Welcome Section */}
      <section style={isMobile ? mobileWelcomeSection : welcomeSection}>
        <div style={container}>
          <div style={isMobile ? mobileWelcomeGrid : welcomeGrid}>
            <div style={welcomeImage}>
              <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8f9fa' }}>
                {/* Image with fade transition */}
                <img
                  src={welcomeImages[welcomeImageIndex]}
                  alt={`Haribalaji Traders Showcase ${welcomeImageIndex + 1}`} // Updated alt text
                  style={{
                    ...welcomeImg,
                    position: 'relative', // Changed from absolute
                    opacity: 1,
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                />

                {/* Left Arrow */}
                <button
                  onClick={() => setWelcomeImageIndex((prev) => (prev === 0 ? welcomeImages.length - 1 : prev - 1))}
                  style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(255,255,255,0.7)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    zIndex: 2,
                  }}
                >
                  <FiChevronLeft size={20} color="#333" />
                </button>

                {/* Right Arrow */}
                <button
                  onClick={() => setWelcomeImageIndex((prev) => (prev + 1) % welcomeImages.length)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(255,255,255,0.7)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    zIndex: 2,
                  }}
                >
                  <FiChevronRight size={20} color="#333" />
                </button>

                {/* Indicator Dots */}
                <div style={{
                  position: 'absolute',
                  bottom: '15px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'flex',
                  gap: '8px',
                }}>
                  {welcomeImages.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setWelcomeImageIndex(i)}
                      style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        border: 'none',
                        background: i === welcomeImageIndex ? '#cbafca' : 'rgba(255,255,255,0.6)',
                        cursor: 'pointer',
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div style={welcomeContent}>
              <h2 style={welcomeTitle}>Welcome to Hari Balaji Traders</h2> {/* Updated title */}
              <p style={welcomeText}>
                Hari Balaji Traders is dedicated to enhancing your celebrations with a stunning array of fireworks.
                As a trusted name in the industry, we offer an extensive selection of high-quality crackers and
                fireworks, all available at competitive prices.
              </p>
              <p style={welcomeText}>
                From Diwali to New Year's Eve, weddings to birthdays, our fireworks are designed to add excitement
                and joy to every occasion. Each item in our collection is chosen with care, ensuring it delivers
                the vibrant displays and bursts of color that make your celebrations truly special.
              </p>
              <p style={welcomeText}>
                Our commitment goes beyond just offering fireworks; we aim to provide the spark that turns moments
                into cherished memories. By combining quality with affordability, Hari Balaji Traders ensures your
                festivities are as brilliant as they are unforgettable.
              </p>
            </div>
          </div>

          {/* Features Grid */}
          <div style={featuresContainer}>
            <div style={isMobile ? mobileFeaturesGrid : featuresGrid}>
              <div style={featureCard} className="feature-card">
                <FiAward style={featureCardIcon} className="feature-icon" />
                <h4 style={featureCardTitle}>High-Quality Fireworks</h4>
                <p style={featureCardText}>Premium quality fireworks crafted with excellence</p>
              </div>
              <div style={featureCard} className="feature-card">
                <FiClock style={featureCardIcon} className="feature-icon" />
                <h4 style={featureCardTitle}>Dependable On-Time Delivery</h4>
                <p style={featureCardText}>Reliable delivery services for all your orders</p>
              </div>
              <div style={featureCard} className="feature-card">
                <FiStar style={featureCardIcon} className="feature-icon" />
                <h4 style={featureCardTitle}>Top-Quality Sivakasi Fireworks</h4>
                <p style={featureCardText}>Authentic Sivakasi fireworks for the best experience</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section style={{ ...productsSection, backgroundColor: '#fdf7fd', marginBottom: '80px' }}>
        <div style={container}>
          <div style={sectionHeader}>
            <h2 style={sectionTitle1}>Featured Products</h2>
            <p style={sectionSubtitle1}>Handpicked crackers for your celebrations</p>
          </div>

          {productsLoading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>Loading products...</div>
          ) : (
            <div style={{ position: 'relative' }}>
              {/* Navigation Arrows */}
              {currentProductIndex > 0 && (
                <button
                  onClick={handlePrevProducts}
                  className="product-nav-arrow"
                  style={{
                    position: 'absolute',
                    left: '-20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: '#5e045bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                    zIndex: 10,
                    boxShadow: '0 4px 12px rgba(94, 4, 91, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#cbafca'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#5e045bff'}
                >
                  <FiChevronLeft />
                </button>
              )}

              {currentProductIndex + productsPerPage < featuredProducts.length && (
                <button
                  onClick={handleNextProducts}
                  className="product-nav-arrow"
                  style={{
                    position: 'absolute',
                    right: '-20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: '#5e045bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                    zIndex: 10,
                    boxShadow: '0 4px 12px rgba(94, 4, 91, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#cbafca'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#5e045bff'}
                >
                  <FiChevronRight />
                </button>
              )}

              {/* Products Grid */}
              <div 
                className="featured-products-grid"
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(5, 1fr)',
                  gap: '20px',
                  marginTop: '40px',
                  overflowX: isMobile ? 'auto' : 'visible',
                  scrollSnapType: isMobile ? 'x mandatory' : 'none',
                  WebkitOverflowScrolling: 'touch',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {currentProducts.map((product) => (
                  <div key={product.id} className="featured-product-card" style={{
                    backgroundColor: 'white',
                    borderRadius: isMobile ? '8px' : '12px',
                    padding: isMobile ? '10px' : '15px',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'transform 0.3s ease',
                    border: '1px solid #eee',
                    scrollSnapAlign: isMobile ? 'start' : 'none',
                    minWidth: isMobile ? '200px' : 'auto',
                    maxWidth: isMobile ? '200px' : 'auto',
                  }}>
                    <div style={{
                      width: '100%',
                      height: isMobile ? '120px' : '180px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      marginBottom: isMobile ? '10px' : '15px'
                    }}>
                      <img
                        src={product.prodImage}
                        alt={product.prodName}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onError={(e) => { e.target.src = banner1 }}
                      />
                    </div>
                    <h3 style={{ fontSize: isMobile ? '0.85rem' : '1.1rem', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>{product.prodName}</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto', flexWrap: isMobile ? 'wrap' : 'nowrap', gap: isMobile ? '8px' : '0' }}>
                      <div>
                        <span style={{ fontSize: isMobile ? '0.9rem' : '1.2rem', fontWeight: 'bold', color: colors.secondary }}>₹{product.discountPrice}</span>
                        <span style={{ fontSize: isMobile ? '0.65rem' : '0.8rem', color: '#999', textDecoration: 'line-through', marginLeft: '8px' }}>₹{product.prodPrice}</span>
                      </div>
                      <Link to="/quick-purchase" style={{
                        padding: isMobile ? '6px 10px' : '8px 15px',
                        backgroundColor: colors.primary,
                        color: 'white',
                        borderRadius: '20px',
                        textDecoration: 'none',
                        fontSize: isMobile ? '0.65rem' : '0.8rem',
                        fontWeight: 'bold'
                      }}>Buy Now</Link>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination Dots */}
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '30px' }}>
                {Array.from({ length: Math.ceil(featuredProducts.length / productsPerPage) }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentProductIndex(index * productsPerPage)}
                    style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      border: 'none',
                      backgroundColor: currentProductIndex === index * productsPerPage ? '#5e045bff' : '#ddd',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  />
                ))}
              </div>
            </div>
          )}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link to="/quick-purchase" style={productButton}>View All Products</Link>
          </div>
        </div>
      </section>

      {/* Product Categories Section */}
      <section style={isMobile ? mobileProductsSection : productsSection}>
        <div style={container}>
          <div style={sectionHeader}>
            <h2 style={sectionTitle1}>Our Fireworks Categories</h2>
            <p style={sectionSubtitle1}>Explore our wide range of premium fireworks by category</p>
          </div>

          <div style={isMobile ? mobileProductsGrid : productsGrid}>
            {productCategories.map((product) => (
              <div key={product.id} style={productCard} className="product-card">
                <div style={productIcon}>{product.icon}</div>
                <h3 style={productTitle}>{product.name}</h3>
                <p style={productDescription}>{product.description}</p>
                <Link to="/quick-purchase" style={productButton} className="product-button">Explore More</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Branches Section */}
      <section style={isMobile ? mobileBranchesSection : branchesSection}>
        <div style={container}>
          <div style={branchesSectionHeader}>
            <h2 style={sectionTitle}>Our Locations</h2>
            <p style={sectionSubtitle}>Visit us at our conveniently located branches</p>
          </div>
          <div style={isMobile ? mobileBranchesGrid : branchesGrid}>
            <div style={mapContainer} className="map-container">
              <div style={mapHeader}>
                <h3 style={mapTitle}>Find Our Locations</h3>
                <p style={mapSubtitle}>Click on the markers to see branch details</p>
              </div>
              <div
                style={{
                  ...mapPlaceholder,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "50%",
                    height: "200px",
                    borderRadius: "2px",
                    overflow: "hidden",
                  }}
                >
                  {/* Google Maps iframe */}
                  <iframe
                    title="Haribalaji Traders Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.6234567890123!2d77.83677407501234!3d9.417287890123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMjUnMDIuMiJOIDc3wrA1MCcyMS43IkU!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: 0,
                      pointerEvents: "none",
                    }}
                  ></iframe>

                  {/* Clickable overlay */}
                  <a
                    href="https://maps.app.goo.gl/zRtKVvvHdGnAZfmA7"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "transparent",
                      textDecoration: "none",
                      zIndex: 10,
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      paddingBottom: "8px",
                    }}
                  >
                    <span
                      style={{
                        color: "#000",
                        fontWeight: "600",
                        fontSize: "0.8rem",
                        backgroundColor: "rgba(255,255,255,0.85)",
                        padding: "4px 8px",
                        borderRadius: "4px",
                      }}
                    >
                      Click to open in Google Maps
                    </span>
                  </a>
                </div>
              </div>


              <div style={mapNote}>
                <FiMapPin style={{ marginRight: '6px', color: '#f1c70cff', fontSize: '0.8rem' }} />
                <span style={{ fontSize: '0.8rem', color: '#474547ff', }}>Red markers indicate our branch locations</span>
              </div>
            </div>
            {/* QR Code Container */}
            <div style={qrContainer} className="qr-container">
              <div style={qrContent}>
                <div>
                  <h3 style={qrTitle}>Scan to Visit Location</h3>
                  <p style={qrDescription}>
                    Use your phone's camera to scan this QR code
                  </p>
                </div>
                <div style={qrCodeWrapper}>
                  <img src={Qr} alt="QR Code for Location" style={qrCodeImage} />
                </div>
              </div>
              {/* Instructions outside the card */}
              <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                <div style={qrInstructions}>
                  <FiSmartphone style={qrInstructionIcon} />
                  <span>Open camera app and point at QR code</span>
                </div>
                <div style={qrInstructions}>
                  <FiNavigation style={qrInstructionIcon} />
                  <span>Follow the link to get directions</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section style={isMobile ? mobileSafetySection : safetySection}>
        <div style={container}>
          <div style={sectionHeader}>
            <h2 style={sectionTitle1}>Safety Guidelines</h2>
            <p style={sectionSubtitle1}>Celebrate responsibly with these essential safety tips</p>
          </div>

          <div style={isMobile ? mobileSafetyGrid : safetyGrid}>
            <div style={safetyCard} className="safety-card">
              <FiAlertTriangle style={safetyIcon} />
              <h4 style={safetyTitle}>Use Open Spaces</h4>
              <p style={safetyText}>Always light crackers in clear, open areas away from buildings and dry grass</p>
            </div>

            <div style={safetyCard} className="safety-card">
              <FiUser style={safetyIcon} />
              <h4 style={safetyTitle}>Adult Supervision</h4>
              <p style={safetyText}>Only adults should handle fireworks. Keep children at a safe distance</p>
            </div>

            <div style={safetyCard} className="safety-card">
              <FiShield style={safetyIcon} />
              <h4 style={safetyTitle}>Water Ready</h4>
              <p style={safetyText}>Keep water sources nearby for emergencies and proper disposal</p>
            </div>

            <div style={safetyCard} className="safety-card">
              <FiCheck style={safetyIcon} />
              <h4 style={safetyTitle}>Never Relight</h4>
              <p style={safetyText}>Do not attempt to relight a dud firework. Wait and soak in water</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Equal Height Containers */}
      <section style={isMobile ? mobileContactSection : contactSection}>
        <div style={container}>
          <div style={sectionHeader}>
            <h2 style={sectionTitle}>Get In Touch</h2>
            <p style={sectionSubtitle}>We're here to help you create unforgettable celebrations</p>
          </div>
          <div style={isMobile ? mobileContactGrid : contactGrid}>
            {/* Image Container */}
            <div style={contactImage}>
              <img src={hero_bg} alt="Contact Us" style={contactImg} />
              <div style={contactImageOverlay}>
                <h3 style={contactImageTitle}>Let's Create Magic Together</h3>
                <p style={contactImageText}>
                  Reach out to us for bulk orders, special events, or any inquiries about our premium fireworks collection.
                </p>
                <div style={contactImageFeatures}>
                  <div style={contactImageFeature}>
                    <FiClock style={contactFeatureIcon} />
                    <span>Quick Response</span>
                  </div>
                  <div style={contactImageFeature}>
                    <FiAward style={contactFeatureIcon} />
                    <span>Expert Advice</span>
                  </div>
                  <div style={contactImageFeature}>
                    <FiShoppingCart style={contactFeatureIcon} />
                    <span>Bulk Order Discounts</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Form Container */}
            <div style={contactForm}>
              <form onSubmit={handleContactSubmit} style={form}>
                <div style={isMobile ? mobileInputGroup : inputGroup}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={getInputStyle(isMobile)}
                    className="contact-input"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={getInputStyle(isMobile)}
                    className="contact-input"
                  />
                </div>
                <div style={isMobile ? mobileInputGroup : inputGroup}>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    style={getInputStyle(isMobile)}
                    className="contact-input"
                  />
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    style={getInputStyle(isMobile)}
                    className="contact-input"
                  >
                    <option value="">Select Subject</option>
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Bulk Order">Bulk Order</option>
                    <option value="Product Question">Product Question</option>
                  </select>
                </div>
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="4"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  style={getTextareaStyle(isMobile)}
                  className="contact-input"
                ></textarea>

                <input type="hidden" name="companyId" value={formData.companyId} />

                {submitStatus === 'success' && (
                  <div style={successMessage}>Message sent successfully!</div>
                )}
                {submitStatus === 'error' && (
                  <div style={errorMessage}>Failed to send message. Please try again.</div>
                )}

                <button type="submit" style={getSubmitButtonStyle(isMobile)} className="submit-button" disabled={isSubmittingContact}>
                  {isSubmittingContact ? 'Sending...' : 'Send Message'}
                  <FiSend style={{ marginLeft: '8px' }} />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

const handlePriceListDownload = () => {
  const link = document.createElement('a');
  link.href = priceListPDF;
  link.download = 'Haribalaji-Traders-Price-List.pdf'; // Updated filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const colors = {
  primary: '#cbafca',
  secondary: '#5e045bff',
  accent: '#d4c0d3',
  background: '#FFFFFF',
  lightBackground: '#F8F9FA',
  darkBackground: '#1a1a1a',
  text: '#47482d23',
  lightText: '#718096',
  border: '#E2E8F0'
};




const shopNowContainer = {
  position: 'fixed',
  bottom: '180px', // Above the download button
  right: '20px',
  zIndex: 1000,
  maxWidth: '150px',
  height: 'auto',
  transition: 'all 0.3s ease',
};

const shopNowImg = {
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
  display: 'block',
  cursor: 'pointer',
  animation: 'blink 2s infinite', // Only shop now blinks
};
const shopNowContent = {
  textAlign: 'center',
};
// const shopNowImageWrapper = {
//   position: 'relative',
//   borderRadius: '8px',
//   overflow: 'hidden',
//   cursor: 'pointer',
//   marginBottom: '0.8rem',
//   transition: 'all 0.3s ease',
//   // REMOVE THIS LINE:
//   // border: `2px solid ${colors.secondary}`,
//   // Or if you want to remove completely:
//   border: 'none',
// };

// const shopNowOverlay = {
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100px',

//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   justifyContent: 'center',
//   transition: 'all 0.3s ease',
//   color: 'white',
//   borderRadius: '6px',
//   opacity: 0,
// };

// const shopNowIcon = {
//   fontSize: '1.5rem',
//   marginBottom: '0.5rem',
// };

// const shopNowText = {
//   fontSize: '0.7rem',
//   fontWeight: '600',
//   textAlign: 'center',
// };

// const shopNowButton = {
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: '100%',
//   padding: '0.6rem',
//   background: colors.secondary, // Red color
//   color: 'white',
//   border: 'none',
//   borderRadius: '6px',
//   fontSize: '0.8rem',
//   fontWeight: '600',
//   cursor: 'pointer',
//   transition: 'all 0.3s ease',
//   boxShadow: '0 4px 12px rgba(178, 34, 34, 0.3)',
// };

// Add hover effects
// const hoverEffects = `
//   .shop-now-image-wrapper:hover .shop-now-overlay {
//     opacity: 1;
//   }

//   .shop-now-image-wrapper:hover .shop-now-img {
//     transform: scale(1.05);
//   }

//   .shop-now-button:hover {
//     background: #9a1a1a;
//     transform: translateY(-2px);

//   }
// `;

// Add this to your existing style tag
const priceListImg = {
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
  display: 'block',
  transition: 'all 0.3s ease',
  borderRadius: '22px',
  transform: 'scale(1.15)', // 15% zoom - good balance
  transformOrigin: 'center center',
};

const priceListContainer = {
  position: 'fixed',
  bottom: '90px', // Move download button down
  right: '20px',
  zIndex: 1000,
  background: 'transparent',
  padding: '0',
  border: 'none',
  maxWidth: '150px',
  height: 'auto',
  transition: 'all 0.3s ease',
  animation: 'fadeInUp 0.5s ease',
};
const priceListContent = {
  textAlign: 'center',
};

const priceListTitle = {
  fontSize: '0.9rem',
  fontWeight: '700',
  color: colors.text,
  marginBottom: '0.8rem',
};

const priceListImageWrapper = {
  position: 'relative',
  borderRadius: '8px',
  overflow: 'hidden',
  cursor: 'pointer',
  marginBottom: '0.8rem',
  transition: 'all 0.3s ease',
};


const priceListOverlay = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '120px', // Explicitly set same height
  background: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease',
  color: 'white',
  borderRadius: '8px',
};

const downloadIcon = {
  fontSize: '1.5rem',
  marginBottom: '0.5rem',
};

const downloadText = {
  fontSize: '0.7rem',
  fontWeight: '600',
  textAlign: 'center',
};

const downloadButton = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '0.6rem',
  background: colors.primary,
  color: colors.darkBackground,
  border: 'none',
  borderRadius: '6px',
  fontSize: '0.8rem',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
};


const container = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem',
  fontFamily: "'Roboto', sans-serif"
};

// Enhanced Top Contact Bar Styles
const topContactBar = {
  background: '#ffffffff',
  color: '#0e0e0eff',
  padding: '0.75rem 0',
  fontSize: '0.9rem',
  borderBottom: '2px solid #cbafca',
  width: '100%',
  zIndex: 1000,
  position: 'relative'
};

const topContactContent = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '1rem',
};

const contactInfoItems = {
  display: 'flex',
  gap: '2rem',
  flexWrap: 'wrap',
  alignItems: 'center',
};

const contactInfoItem = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
};

const contactInfoIcon = {
  fontSize: '0.9rem',
  color: '#cbafca',
  minWidth: '16px'
};

// Contact Section - FIXED MOBILE STYLES
const contactSection = {
  padding: '0 0 4rem 0',
  background: colors.lightBackground,
  position: 'relative',
};

const mobileContactSection = {
  ...contactSection,
  padding: '0 0 2rem 0',
};

const contactGrid = {
  display: 'flex', // Use flex instead of grid
  gap: '3rem',
  alignItems: 'stretch',
  minHeight: '500px',
};
const mobileContactGrid = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  minHeight: 'auto',
};

const contactImage = {
  position: 'relative',
  borderRadius: '15px',
  overflow: 'hidden',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  flex: '1', // Equal flex growth
  minHeight: '500px',
};

const contactImg = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const contactImageOverlay = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)',
  color: 'white',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const contactImageTitle = {
  fontSize: '2rem',
  fontWeight: '700',
  marginBottom: '1rem',
};

const contactImageText = {
  fontSize: '1.1rem',
  lineHeight: '1.6',
  marginBottom: '2rem',
  opacity: 0.9,
};

const contactImageFeatures = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

const contactImageFeature = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  fontSize: '1rem',
};

const contactFeatureIcon = {
  fontSize: '1.2rem',
  color: '#cbafca',
};
const estimateButton = {
  background: '#cbafca',
  borderRadius: '5px',
  padding: '0.5rem 1rem',
  transition: 'all 0.3s ease',
};

const estimateButtonLink = {
  color: colors.darkBackground,
  textDecoration: 'none',
  fontWeight: '600',
  fontSize: '0.8rem',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap'
};

// Banner Section with Right to Left Transition
const bannerSection = {
  height: '50vh',
  minHeight: '450px',
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  marginTop: '0.5px',
};

const mobileBannerSection = {
  ...bannerSection,
  height: '45vh',
  minHeight: '350px',
};

const bannerContainer = {
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
};

const bannerSlide = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  transition: 'all 0.8s ease-in-out',
};
const bannerOverlay = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 100%)',
  zIndex: 1,
};

const bannerContent = {
  position: 'relative',
  zIndex: 2,
  textAlign: 'center',
  color: 'white',
  maxWidth: '900px',
  padding: '0 2rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  margin: '0 auto',
};

const heroBadge = {
  display: 'inline-block',
  background: 'linear-gradient(145deg, #cbafca 0%, #cbafca 100%)',
  color: 'white',
  padding: '0.8rem 2rem',
  borderRadius: '30px',
  fontSize: '0.95rem',
  fontWeight: '700',
  marginBottom: '2rem',
  textTransform: 'uppercase',
  letterSpacing: '1.5px',
  boxShadow: '0 15px 35px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  animation: 'float 3s ease-in-out infinite',
};

const bannerTitle = {
  fontSize: '3rem',
  fontWeight: '800',
  marginBottom: '1.5rem',
  textShadow: '3px 3px 10px rgba(0,0,0,0.8)',
  lineHeight: '1.2',
  color: '#ffffff',
  fontFamily: "'Poppins', 'Montserrat', sans-serif",
  letterSpacing: '2px',
  whiteSpace: 'nowrap',
};

const mobileBannerTitle = {
  ...bannerTitle,
  fontSize: '2.2rem',
  color: '#ffffff',
  fontFamily: "'Poppins', 'Montserrat', sans-serif",
  letterSpacing: '1.5px',
  whiteSpace: 'normal',
};

const bannerSubtitle = {
  fontSize: '1.4rem',
  marginBottom: '2.5rem',
  textShadow: '2px 2px 6px rgba(0,0,0,0.8)',
  lineHeight: '1.8',
  fontWeight: '400',
  maxWidth: '700px',
  color: '#ffffff',
};

const mobileBannerSubtitle = {
  ...bannerSubtitle,
  fontSize: '1rem',
  marginBottom: '2rem',
  color: '#ffffff',
};

const bannerButtonGroup = {
  display: 'flex',
  gap: '1rem',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
};

const websiteLink = {
  color: colors.primary,
  fontSize: '1.1rem',
  fontWeight: '700',
  textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
  letterSpacing: '1px',
};

// Welcome Section with Image on Left
// Updated Welcome Section with Image on Left
const welcomeSection = {
  padding: '2rem 0', // Increased padding
  background: colors.background,
};

const mobileWelcomeSection = {
  ...welcomeSection,
  padding: '2rem 0',
};

const welcomeGrid = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '3rem', // Increased gap
  alignItems: 'stretch', // Changed to stretch for equal height
  minHeight: '500px', // Set minimum height
};

const mobileWelcomeGrid = {
  ...welcomeGrid,
  gridTemplateColumns: '1fr',
  gap: '2rem',
  minHeight: 'auto',
};



// Option 2: Controlled size with contain
const welcomeImg = {
  width: '90%', // Reduce width
  height: '90%', // Reduce height
  objectFit: 'contain', // Show full image without cropping
  display: 'block',
  margin: 'auto', // Center the image
};

// Updated Welcome Image container
const welcomeImage = {
  position: 'relative',
  borderRadius: '15px',
  overflow: 'hidden',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  height: '100%', // Full height of container
  minHeight: '400px', // Minimum height
  display: 'flex', // Add flex to center the image
  alignItems: 'center', // Center vertically
  justifyContent: 'center', // Center horizontally
  background: '#f8f9fa', // Background for empty space
};

// Updated Welcome Content
const welcomeContent = {
  paddingLeft: '2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center', // Center content vertically
  height: '100%', // Full height
};

const mobileWelcomeContent = {
  ...welcomeContent,
  paddingLeft: '0',
  paddingTop: '0',
};

const welcomeTitle = {
  fontSize: '2.5rem',
  fontWeight: '700',
  color: 'black',
  marginBottom: '1.5rem',
  fontFamily: "'Roboto', sans-serif",
};

const welcomeText = {
  fontSize: '1.1rem',
  lineHeight: '1.7',
  color: 'black',
  marginBottom: '1rem',
  textAlign: 'left',
  fontFamily: "'Roboto', sans-serif",
};









const contactCallout = {
  background: colors.lightBackground,
  padding: '2rem',
  borderRadius: '10px',
  margin: '3rem 0',
  border: `2px solid ${colors.primary}`,
};

const calloutItem = {
  textAlign: 'center',
};

const calloutTitle = {
  fontSize: '1.5rem',
  color: colors.secondary,
  display: 'block',
};

const calloutSubtitle = {
  fontSize: '1rem',
  color: colors.text,
  margin: '0.5rem 0',
  fontWeight: '600',
};

const featuresContainer = {
  marginTop: '2rem',
};

const featuresGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '2rem',
};

const mobileFeaturesGrid = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
};

const featureCard = {
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  padding: '1.5rem 1.2rem',
  borderRadius: '15px',
  textAlign: 'center',
  border: '2px solid #5e045bff',
  boxShadow: '0 10px 25px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  transition: 'all 0.4s ease',
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
};

const featureCardIcon = {
  fontSize: '2.5rem',
  color: '#5e045bff',
  marginBottom: '1rem',
  background: 'linear-gradient(145deg, #5e045bff 0%, #5e045bff 100%)',
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 1rem auto',
  boxShadow: '0 10px 25px rgba(94, 4, 91, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  border: 'none',
  transition: 'all 0.4s ease',
  color: 'white',
};

const featureCardTitle = {
  fontSize: '1.1rem',
  fontWeight: '700',
  color: '#2D2D2D',
  marginBottom: '0.6rem',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  lineHeight: '1.3',
};

const featureCardText = {
  color: '#5A5A5A',
  lineHeight: '1.5',
  fontSize: '0.85rem',
  fontWeight: '500',
  margin: '0',
};

// Mobile-specific styles for price list
const mobilePriceListContainer = {
  bottom: '15px',
  right: '15px',
  maxWidth: '80px',
};

const mobilePriceListImageWrapper = {
  // Smaller on mobile
};

const mobilePriceListImg = {
  height: '80px',
};

const mobilePriceListOverlay = {
  // Adjust overlay for mobile
};

const mobileDownloadIcon = {
  fontSize: '1rem',
  marginBottom: '0.2rem',
};

const mobileDownloadText = {
  fontSize: '0.5rem',
};


const productsSection = {
  padding: "4rem 1rem",
  backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${crackerbanner5})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};


const mobileProductsSection = {
  ...productsSection,
  padding: '3rem 0',
};



const productsGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: '2rem',
  marginTop: '0.1rem',
};

const mobileProductsGrid = {
  ...productsGrid,
  gridTemplateColumns: '1fr',
  gap: '1.5rem',
};

const productCard = {
  background: 'rgba(255, 255, 255, 0.95)',
  padding: '1.5rem 1.2rem',
  borderRadius: '15px',
  textAlign: 'center',
  boxShadow: '0 10px 25px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  border: 'none',
  minHeight: '220px',
  transition: 'all 0.4s ease',
  position: 'relative',
  zIndex: 2,
  cursor: 'pointer',
  backdropFilter: 'blur(10px)',
};

const productIcon = {
  fontSize: '3rem',
  marginBottom: '1rem',
  filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))',
};

const productTitle = {
  fontSize: '1.1rem',
  fontWeight: '700',
  color: colors.secondary,
  marginBottom: '0.8rem',
};

const productDescription = {
  color: colors.lightText,
  lineHeight: '1.5',
  marginBottom: '1.2rem',
  fontSize: '0.85rem',
};

const productButton = {
  display: 'inline-block',
  padding: '0.7rem 1.5rem',
  background: 'linear-gradient(145deg, #5e045bff 0%, #5e045bff 100%)',
  color: '#ffffff',
  textDecoration: 'none',
  borderRadius: '20px',
  fontWeight: '700',
  transition: 'all 0.3s ease',
  fontSize: '0.85rem',
  boxShadow: '0 10px 25px rgba(94, 4, 91, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
};


const sectionHeader = {
  textAlign: "center",
  marginBottom: "20px", // reduce from 40px or 60px
};




// Updated Branches Section
const branchesSection = {
  padding: "3rem 0",
  position: "relative",
  background: colors.lightBackground,
};

const mobileBranchesSection = {
  ...branchesSection,
  padding: '2rem 0',
};

const branchesGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "2rem",
  alignItems: "stretch",
};

const mobileBranchesGrid = {
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
};

// Updated Map Container - Fixed height and width
const mapContainer = {
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  padding: '2rem',
  borderRadius: '20px',
  boxShadow: '0 15px 35px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  transition: 'all 0.3s ease',
  border: '2px solid #5e045bff',
  minHeight: '300px',
  height: '300px',
  display: 'flex',
  flexDirection: 'column',
};
// Add this with your other style constants at the bottom
const headerBottomBorder = {
  background: '#cbafca',
  height: '2px',
  width: '100%',
  margin: '0',
  padding: '0',
  border: 'none',
};
// Updated Map Header
const mapHeader = {
  textAlign: 'center',
  marginBottom: '1rem',
};

const mapTitle = {
  fontSize: '1.3rem',
  fontWeight: '600',
  color: 'black',
  marginBottom: '0.5rem',
};

const mapSubtitle = {
  color: '#474547ff',
  fontSize: '0.9rem',
};

// Updated Map Placeholder - Fixed height
const mapPlaceholder = {
  marginTop: "1rem",
  width: "100%",
  height: "250px",   // 👈 FIXED HEIGHT
  borderRadius: "10px",
  overflow: "hidden",
  alignItems: "center",
};


// Static Map Styles
const mapLink = {
  display: 'block',
  width: '100%',
  height: '100%',
  position: 'relative',
  textDecoration: 'none',
};

const mapImage = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '10px',
};

const mapClickOverlay = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.3)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '0.9rem',
  fontWeight: '600',
  borderRadius: '10px',
  opacity: 0,
  transition: 'opacity 0.3s ease',
};

// Add hover effect
const mapLinkHover = {
  opacity: 1,
};

const mapNote = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.8rem',
  color: colors.lightText,
  marginTop: 'auto',
  paddingTop: '0.5rem',
};

// Updated QR Container - Fixed height and width to match map
const qrContainer = {
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  padding: '2rem',
  borderRadius: '20px',
  boxShadow: '0 15px 35px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  transition: 'all 0.3s ease',
  border: '2px solid #5e045bff',
  minHeight: '300px',
  height: '300px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

// Updated QR Content
const qrContent = {
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%',
  width: '100%',
};

const qrTitle = {
  fontSize: '1.3rem',
  fontWeight: '600',
  color: 'black',
  marginBottom: '0.5rem',
};

const qrDescription = {
  color: '#474547ff',
  marginBottom: '1rem',
  lineHeight: '1.4',
  fontSize: '0.85rem',
};

// Updated QR Code Wrapper
const qrCodeWrapper = {
  marginBottom: '1rem',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const qrCodeImage = {
  width: '140px', // Slightly smaller to fit better
  height: '140px',
  borderRadius: '10px',
  border: '2px solid #cbafca',
  padding: '6px',
  background: 'white',
};

const qrInstructions = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '0.5rem',
  fontSize: '0.8rem',
  color: '#474547ff',
};

const qrInstructionIcon = {
  fontSize: '0.9rem',
  color: '#cbafca',
};

// Updated Section Header for Branches
const branchesSectionHeader = {
  textAlign: "center",
  marginBottom: "2rem",
};


const mapIcon = {
  fontSize: '3rem',
  marginBottom: '1rem',
};

const mapText = {
  fontSize: '1.2rem',
  fontWeight: '600',
  marginBottom: '0.5rem',
};

const mapDescription = {
  fontSize: '0.9rem',
  opacity: 0.9,
};




const navButton = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'rgba(255, 255, 255, 1)',
  border: 'none',
  color: colors.darkBackground,
  fontSize: '1.5rem',
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease',
  zIndex: 10,
  '@media (max-width: 768px)': {
    display: 'none', // Hide in mobile view
  },
};

const navButtonPrev = {
  ...navButton,
  left: '2rem',
};

const navButtonNext = {
  ...navButton,
  right: '2rem',
};

// Banner Indicators
const bannerIndicators = {
  position: 'absolute',
  bottom: '2rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '0.8rem',
  zIndex: 10,
};

const bannerIndicator = {
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  border: 'none',
  background: 'rgba(255, 255, 255, 0.5)',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
};

const activeIndicator = {
  background: '#cbafca',
  transform: 'scale(1.3)',
};

// Primary Button
const primaryButton = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1.0rem 1.3rem',
  background: '#ffffff',
  color: '#5e045bff',
  textDecoration: 'none',
  borderRadius: '30px',
  fontWeight: '700',
  fontSize: '1.1rem',
  transition: 'all 0.3s ease',
  border: '2px solid #5e045bff',
  cursor: 'pointer',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  boxShadow: '0 15px 35px rgba(94, 4, 91, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
};



const sectionTitle = {
  fontSize: '2.5rem',
  fontWeight: '700',
  color: 'black',
  marginBottom: '1rem',
};
const sectionTitle1 = {
  fontSize: '2.5rem',
  fontWeight: '700',
  color: 'white',
  marginBottom: '1rem',
};
const sectionSubtitle = {
  fontSize: '1.1rem',
  color: colors.lightText,
  maxWidth: '600px',
  margin: '0 auto',
  lineHeight: '1.6',
};
const sectionSubtitle1 = {
  fontSize: '1.1rem',
  color: 'white',
  maxWidth: '600px',
  margin: '0 auto',
  lineHeight: '1.6',
};


// Input Group for Mobile
const inputGroup = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '1rem',
};

const mobileInputGroup = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

const contactForm = {
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  padding: '3rem',
  borderRadius: '20px',
  border: '1px solid #e0e0e0',
  boxShadow: '0 15px 35px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  flex: '1',
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column',
};

const form = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
};

const getInputStyle = (isMobile) => ({
  padding: isMobile ? '0.6rem' : '1rem',
  background: '#f3e5f5',
  border: '2px solid #5e045bff',
  borderRadius: '8px',
  color: 'black',
  fontSize: isMobile ? '0.85rem' : '1rem',
  outline: 'none',
  transition: 'all 0.3s ease',
  width: '100%',
  boxSizing: 'border-box',
});

const getTextareaStyle = (isMobile) => ({
  ...getInputStyle(isMobile),
  resize: 'vertical',
  minHeight: isMobile ? '80px' : '120px',
  fontFamily: 'inherit',
});

const getSubmitButtonStyle = (isMobile) => ({
  background: 'linear-gradient(145deg, #5e045bff 0%, #5e045bff 100%)',
  color: '#ffffff',
  border: '2px solid #5e045bff',
  padding: isMobile ? '0.8rem 1.2rem' : '1.3rem 2rem',
  borderRadius: '30px',
  fontSize: isMobile ? '0.85rem' : '1.05rem',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease',
  width: '100%',
  boxShadow: '0 15px 35px rgba(94, 4, 91, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  textTransform: 'uppercase',
});

const successMessage = {
  background: '#C6F6D5',
  color: '#22543D',
  padding: '1rem',
  borderRadius: '8px',
  textAlign: 'center',
  marginBottom: '1rem',
  border: '1px solid #9AE6B4'
};

const errorMessage = {
  background: '#FED7D7',
  color: '#742A2A',
  padding: '1rem',
  borderRadius: '8px',
  textAlign: 'center',
  marginBottom: '1rem',
  border: '1px solid #FEB2B2'
};

const safetySection = {
  padding: "4rem 1rem 0 1rem",
  backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${safetyBg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  position: "relative",
  color: "white", // optional if text should turn white
};

const mobileSafetySection = {
  padding: "2.5rem 1rem 0 1rem",
  backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${safetyBg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  color: "white",
};

const safetyGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '2rem',
  marginTop: '3rem',
};

const mobileSafetyGrid = {
  ...safetyGrid,
  gridTemplateColumns: '1fr',
  gap: '1.5rem',
  marginTop: '2rem',
};

const safetyCard = {
  background: 'rgba(255, 255, 255, 0.95)',
  padding: '2.5rem 2rem',
  borderRadius: '20px',
  textAlign: 'center',
  border: 'none',
  boxShadow: '0 15px 35px #ebcdebff, inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  transition: 'all 0.4s ease',
  backdropFilter: 'blur(10px)',
  cursor: 'pointer',
  marginBottom: '2rem',
};

const safetyIcon = {
  fontSize: '3rem',
  color: '#5e045bff',
  marginBottom: '1.5rem',
};

const safetyTitle = {
  fontSize: '1.2rem',
  fontWeight: '800',
  color: 'black',
  marginBottom: '1rem',
};

const safetyText = {
  color: 'black',
  lineHeight: '1.6',
  fontSize: '0.95rem',
};

export default Home;
